import {minWidthMedia} from "@irati/ui/src/global/media"
import styled, {css} from "styled-components"

interface TContainer {
  hasBanner?: boolean
}

const Container = styled.div<TContainer>`
  ${({theme, hasBanner}) => css`
    padding-top: ${hasBanner ? theme.spacing.twelve : theme.spacing.five};

    ${minWidthMedia.tablet`
      padding-top: ${hasBanner ? theme.spacing.twelve : theme.spacing.eight};
    `}
  `}

  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.spacing.five};
`

export const ContainerInline = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.spacing.five};
`

export default Container
